/* ===========================================================================
   product-limited.js
   限定商品テンプレート専用スクリプト（小さく保つ）。
   スコープ: .JDS-Product--limited が存在するページのみ動作。
   - html に jds-ltd-active を付与（将来のフック用）
   - prefers-reduced-motion 時は揺れアニメ(JDS-Product--shake)を無効化
   - カートボタン操作後は揺れを止める
   =========================================================================== */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.JDS-Product--limited');
    if (!root) return;

    document.documentElement.classList.add('jds-ltd-active');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.remove('JDS-Product--shake');
    }

    // 一度カート操作したら揺れを止める（キャプチャ段階で拾う）
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (target && target.closest && target.closest('.jds-cart-button')) {
        root.classList.remove('JDS-Product--shake');
      }
    }, true);

    // PC(min-width:720px)でも画像ドットを生成・同期する。
    // SPはセクション内の既存インラインJSが担当（二重生成は childElementCount で防止）。
    var swiper = document.querySelector('#P_image .product-swiper');
    var dotsEl = document.getElementById('product-image-dots');
    if (swiper && dotsEl && window.matchMedia('(min-width: 720px)').matches && dotsEl.childElementCount === 0) {
      var images = swiper.querySelectorAll('img');
      if (images.length > 1) {
        images.forEach(function (_, i) {
          var dot = document.createElement('span');
          dot.className = 'product-image-dot' + (i === 0 ? ' is-active' : '');
          dot.addEventListener('click', function () {
            swiper.scrollTo({ left: i * swiper.clientWidth, behavior: 'smooth' });
          });
          dotsEl.appendChild(dot);
        });
        swiper.addEventListener('scroll', function () {
          var w = swiper.clientWidth || 1;
          var index = Math.round(swiper.scrollLeft / w);
          dotsEl.querySelectorAll('.product-image-dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
          });
        }, { passive: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
